import { Request } from 'redux/types/account';

export default function isRequestAdvisor(userId: Number, request: Request | undefined): boolean {
  return userId === request?.details?.advisorId;
}
